import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./ResetPasswordBlock').then(m => ({default: m.ResetPasswordBlock})),
)

export const resetPasswordBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
})
